import React, { createContext, useContext, forwardRef } from 'react';
import styled from 'styled-components';
import { breakpoints, spacing } from '../../theme/index';
export const GridCol = forwardRef(({ s = '12', m = '6', l = '4', xl = '3', justify, align, children, className, ...rest }, ref) => {
    const breakpoints = useContext(GridContext);
    return (<Col s={s} m={m} l={l} xl={xl} justify={justify} align={align} className={className} breakpoints={breakpoints} ref={ref} {...rest}>
      {children}
    </Col>);
});
const Col = styled.div `
  @media (max-width: ${(props) => (props.breakpoints ? props.breakpoints.s : breakpoints.s)}px) {
    grid-column: auto / span ${(props) => props.s};
    justify-self: ${(props) => props.justify && props.justify.s};
    align-self: ${(props) => props.align && props.align.s};
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.s : breakpoints.s)}px) {
    grid-column: auto / span ${(props) => props.m};
    justify-self: ${(props) => props.justify && props.justify.m};
    align-self: ${(props) => props.align && props.align.m};
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.m : breakpoints.m)}px) {
    grid-column: auto / span ${(props) => props.l};
    justify-self: ${(props) => props.justify && props.justify.l};
    align-self: ${(props) => props.align && props.align.l};
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.l : breakpoints.l)}px) {
    grid-column: auto / span ${(props) => props.xl};
    justify-self: ${(props) => props.justify && props.justify.xl};
    align-self: ${(props) => props.align && props.align.xl};
  }
`;
export const GridRow = forwardRef(({ columns = 12, justifyItems, alignItems, className, children, ...rest }, ref) => {
    const breakpoints = useContext(GridContext);
    return (<Row columns={columns} justifyItems={justifyItems} alignItems={alignItems} className={className} breakpoints={breakpoints} ref={ref} {...rest}>
      {children}
    </Row>);
});
const Row = styled.div `
  /* Row */
  grid-column: 1 / -1;
  grid-row: auto;

  /* Subgrid */
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  grid-template-rows: auto;
  grid-gap: ${spacing.space24};

  @media (max-width: ${(props) => (props.breakpoints ? props.breakpoints.s : breakpoints.s)}px) {
    justify-items: ${(props) => props.justifyItems && props.justifyItems.s};
    align-items: ${(props) => props.alignItems && props.alignItems.s};
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.s : breakpoints.s)}px) {
    justify-items: ${(props) => props.justifyItems && props.justifyItems.m};
    align-items: ${(props) => props.alignItems && props.alignItems.m};
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.m : breakpoints.m)}px) {
    justify-items: ${(props) => props.justifyItems && props.justifyItems.l};
    align-items: ${(props) => props.alignItems && props.alignItems.l};
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.l : breakpoints.l)}px) {
    justify-items: ${(props) => props.justifyItems && props.justifyItems.xl};
    align-items: ${(props) => props.alignItems && props.alignItems.xl};
  }
`;
/* Grid */
const defaultBreakpoints = {
    s: parseInt(breakpoints.s.replace('px', '')),
    m: parseInt(breakpoints.m.replace('px', '')),
    l: parseInt(breakpoints.l.replace('px', '')),
    xl: parseInt(breakpoints.xl.replace('px', '')),
};
const GridContext = createContext(defaultBreakpoints);
export const Grid = forwardRef(({ breakpoints = defaultBreakpoints, columns = 12, justifyItems, alignItems, children, className, ...rest }, ref) => {
    const { s, m, l, xl } = breakpoints;
    return (<GridContext.Provider value={breakpoints}>
        <Container breakpoints={{ s: s, m: m, l: l, xl: xl }} columns={columns} justifyItems={justifyItems} alignItems={alignItems} className={className} ref={ref} {...rest}>
          {children}
        </Container>
      </GridContext.Provider>);
});
const Container = styled.div `
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  grid-template-rows: auto;
  grid-gap: ${spacing.space24};

  @media (max-width: ${(props) => (props.breakpoints ? props.breakpoints.s : breakpoints.s)}px) {
    grid-gap: ${spacing.space24};
    justify-items: ${(props) => props.justifyItems && props.justifyItems.s};
    align-items: ${(props) => props.alignItems && props.alignItems.s};

    ${Row} {
      grid-gap: ${spacing.space24};
    }
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.s : breakpoints.s)}px) {
    grid-gap: ${spacing.space24};
    justify-items: ${(props) => props.justifyItems && props.justifyItems.m};
    align-items: ${(props) => props.alignItems && props.alignItems.m};

    ${Row} {
      grid-gap: ${spacing.space24};
    }
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.m : breakpoints.m)}px) {
    grid-gap: ${spacing.space32};
    justify-items: ${(props) => props.justifyItems && props.justifyItems.l};
    align-items: ${(props) => props.alignItems && props.alignItems.l};

    ${Row} {
      grid-gap: ${spacing.space32};
    }
  }

  @media (min-width: ${(props) => (props.breakpoints ? props.breakpoints.l : breakpoints.l)}px) {
    grid-gap: ${spacing.space32};
    justify-items: ${(props) => props.justifyItems && props.justifyItems.xl};
    align-items: ${(props) => props.alignItems && props.alignItems.xl};

    ${Row} {
      grid-gap: ${spacing.space32};
    }
  }
`;
